import { useQuery } from 'react-query';

import { getFaqData } from '../../../api/customer/customer';

const useFaq = (customerId: string) => {
  const { isLoading, data: faqData } = useQuery(['faq'], () => getFaqData(customerId), {
    select: data => data.data,
    refetchOnMount: false,
  });

  return { isLoading, faqData };
};

export default useFaq;
